import LoadStylesService from 'shared/services/LoadStylesService';

/**
 * Load Confirm Newsletter Popin dynamically
 */

export default class ConfirmNewsletterChunk {
  private readonly body: HTMLElement;

  constructor() {
    this.body = document.querySelector('body');

    /* Load Confirmation Newsletter popin's JS */
    import(
      /* webpackPrefetch: true */
      /* webpackChunkName: 'prefetch-confirmNewsletter' */
      '../../../components/Newsletter/ConfirmNewsletter/ConfirmNewsletter'
    ).then(({ default: ConfirmNewsletter }) => {
      ConfirmNewsletterChunk.addOldCss();

      ConfirmNewsletter.execute();
    });
  }

  /**
   * Load old CSS
   *
   */
  private static addOldCss = () => {
    const newsletterElement: HTMLElement =
      document.querySelector('.js-newsletter');

    if (
      !newsletterElement.classList.contains('js-confirmNewsletter--cssLoaded')
    ) {
      const { cssFileConfirmNewsletter } = newsletterElement.dataset;
      newsletterElement.classList.add('js-confirmNewsletter--cssLoaded');
      LoadStylesService.loaderStyle(cssFileConfirmNewsletter);
    }
  };
}
